import React from 'react'
import styled from 'styled-components'
import LPHeader from 'src/components/layout/Header/LPHeader'
import { Result } from 'antd'
import ButtonCustom from 'src/components/form/Button'
import { useNavigate } from 'react-router-dom'
import { PATH as PATH_HOME } from 'src/pages/homeFlow'

const ForbiddenErrorContainer: React.FC = () => {
  const navigate = useNavigate()
  return (
    <Wrapper>
      <LPHeader />
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <ButtonCustom
            className={'mt-5 btn-black'}
            loading={false}
            onClick={() => navigate(PATH_HOME.FLOW)}
            name={'Back home'}
          />
        }
      />
    </Wrapper>
  )
}

const Wrapper = styled.div``

export default ForbiddenErrorContainer
